import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { MedicineStatus } from 'src/app/medicine-user/enums/medicine-status.enum';
import { IUseMedicine } from 'src/app/medicine-user/models/use-medicine.model';
import { AddToStock, UseMedicine } from 'src/app/medicine-user/state/medicine.actions';
import { AlertStatus } from 'src/app/risk-assessment-user/enums/alert-status.enum';
import { ModuleName } from 'src/app/shared/enums/enums';
import { UiPillStatusEnum } from 'src/app/shared/enums/ui-pill-status.enum';
import { AddToStockModalComponent } from 'src/app/shared/stock-module/add-to-stock-modal/add-to-stock-modal.component';
import { UseStockModalComponent } from 'src/app/shared/stock-module/use-stock-modal/use-stock-modal.component';

@Component({
  selector: 'app-medicine-template',
  templateUrl: './medicine-template.component.html',
  styleUrls: ['./medicine-template.component.scss'],
  standalone: false,
})
export class MedicineTemplateComponent implements OnInit {
  @Input() columnName: string;
  @Input() element: any;

  statusColor: string;
  expiryStatusColor: string;

  private statusMapper = {
    [MedicineStatus.Green]: UiPillStatusEnum.Ok,
    [MedicineStatus.Yellow]: UiPillStatusEnum.UnderThreshold,
    [MedicineStatus.Red]: UiPillStatusEnum.UnderMinimum,
  };

  private expiryStatusMapper = {
    [AlertStatus.Ok]: UiPillStatusEnum.Ok,
    [AlertStatus.Expiring]: UiPillStatusEnum.Expiring,
    [AlertStatus.Expired]: UiPillStatusEnum.Expired,
  };

  constructor(
    private dialog: MatDialog,
    private store: Store
  ) {}

  ngOnInit(): void {
    this.statusColor = this.statusMapper[this.element.stockStatus as MedicineStatus];
    this.expiryStatusColor = this.expiryStatusMapper[this.element.expiryStatus as AlertStatus];
  }

  use(): void {
    this.dialog
      .open(UseStockModalComponent, {
        width: '30rem',
        panelClass: 'mobile-sizing-for-mat-dialogs',
        data: {
          id: `${this.element.id}`,
          currentStock: `${this.element.currentQuantity}`,
          module: ModuleName.MEDICINE,
        },
      })
      .afterClosed()
      .subscribe((result: IUseMedicine) => {
        if (result) {
          this.store.dispatch(new UseMedicine(result));
        }
      });
  }

  addToStock(): void {
    this.dialog
      .open(AddToStockModalComponent, {
        width: '45rem',
        panelClass: 'mobile-sizing-for-mat-dialogs',
        data: {
          id: `${this.element.id}`,
          currentStock: `${this.element.currentQuantity}`,
          module: ModuleName.MEDICINE,
        },
      })
      .afterClosed()
      .subscribe((result: IUseMedicine) => {
        if (result) {
          this.store.dispatch(new AddToStock(result, false));
        }
      });
  }
}
